import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MenuItemForPayment} from '../../../../core/models/cart-item.model';

@Component({
  selector: 'app-throttling-confirmation',
  templateUrl: './throttling-confirmation.component.html',
  styleUrls: ['./throttling-confirmation.component.scss'],
})
export class ThrottlingConfirmationComponent implements OnInit {
  public cartProduct: MenuItemForPayment;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ThrottlingConfirmationComponent>
  ) { }

  ngOnInit() {
    this.initData();
  }

  private initData() {
    if (this.data) {
      this.cartProduct = this.data.cartProduct;
    }
  }

}
